// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AdjudicationCodeModel {
    static getAttributeTypeMap() {
        return AdjudicationCodeModel.attributeTypeMap;
    }
}
AdjudicationCodeModel.discriminator = undefined;
AdjudicationCodeModel.additionalProperties = false;
AdjudicationCodeModel.attributeTypeMap = [
    {
        "name": "carc",
        "baseName": "carc",
        "type": "string"
    },
    {
        "name": "rarc",
        "baseName": "rarc",
        "type": "string"
    },
];
//# sourceMappingURL=adjudicationCodeModel.js.map